import React from "react";
import {
  Input, Label, Spinner 
} from "reactstrap";

function ToggleCheckbox({ checked, onChange, isLoading, id }) {
  return (
    <div className="d-flex gap-3 d-flex flex-column align-items-center">
      {isLoading ? (
        <Spinner className="ms-2" />
      ) : (
        <Input
          type="checkbox"
          id={id}
          switch="none"
          checked={checked}
          onChange={onChange}
        />
      )}
      <Label className="me-1" htmlFor={id} data-on-label="" data-off-label=""></Label>
    </div>
  );
}

export default ToggleCheckbox;